import React, { useEffect } from 'react';
import RadioMechanism from './RadioMechanism';

/*
This component is displayed inside an edit component pop up ,that has data attributes (button, link, image) and it is responsible to
display all the info about the flow attributes of a component that we want to edit
*/
const FlowDataMechanism = (props) => {
  const {
    clickedEdit,
    editor,
    selectedProject,
    target,
    setTarget,
    href,
    setHref,
    targetPageChecked,
    setTargetPageChecked,
    hrefChecked,
    setHrefChecked,
    setDisplayFlowData,
    newWindowChecked,
    setNewWindowChecked,
    transitionById,
    setTransitionById,
    previousPageChecked,
    setPreviousPageChecked,
    insertCustomCodeChecked,
    setInsertCustomCodeChecked,
    setOpenAlert
  } = props;

  const [targets, setTargets] = React.useState(['none']);

  const findPageName = (pageId) => {
    let namePage = 'none';
    const tempData = JSON.parse(localStorage.getItem('data'));
    tempData[selectedProject].pages.forEach((page) => {
      if (page.pageId === pageId) {
        namePage = page.name;
      }
    });
    return namePage;
  };

  /*
    This useEffect is runed when edit link-button-image pop up window is opened and reads the attributes href, function name and target page of the
    component. It also parses and stores to var targets all the available target pages.
    */
  useEffect(() => {
    if (clickedEdit === true && editor.getSelected() !== undefined) {
      const selected = editor.getSelected();

      if (
        selected.attributes.attributes.target_page !== undefined &&
        selected.attributes.attributes.target_page !== 'none'
      ) {
        setDisplayFlowData(true);
        const targetName = findPageName(selected.attributes.attributes.target_page);
        setTarget(targetName);
        setTargetPageChecked(true);
      } else {
        setTarget('none');
        setTargetPageChecked(false);
      }
      if (
        selected.attributes.attributes.href !== undefined &&
        selected.attributes.attributes.href !== ''
      ) {
        setDisplayFlowData(true);
        setHref(selected.attributes.attributes.href);
        setHrefChecked(true);
      } else if(selected.attributes.attributes.target_page === undefined && selected.attributes.attributes['back-button'] === undefined && selected.attributes.attributes['insert-code'] === undefined){
          setHrefChecked(true);
          setHref('');
      }
      else{
        setHref('');
        setHrefChecked(false);
      }

      if(selected.attributes.attributes['back-button'] !== undefined){
        setDisplayFlowData(true);
        setPreviousPageChecked(true);
      }
      else{
        setPreviousPageChecked(false)
      }

      if(selected.attributes.attributes['insert-code'] !== undefined){
        setDisplayFlowData(true);
        setInsertCustomCodeChecked(true);
      }
      else{
        setInsertCustomCodeChecked(false)
      }

      if(selected.attributes.attributes['open-window'] ===  true){
        setNewWindowChecked(true);
      }
      else{
        setNewWindowChecked(false);
      }

      if(selected.attributes.attributes['transition-by-id'] ===  true){
        setTransitionById(true);
      }
      else{
        setTransitionById(false);
      }

      const selectedAttr = selected.attributes.attributes;
      if (
        (selectedAttr.href === undefined || selectedAttr.href === '') &&
        selectedAttr.target_page === undefined && 
        (selectedAttr['attached-subentity-attr'] === 'none' || selectedAttr['attached-subentity-attr'] === undefined) &&
        selectedAttr['back-button'] === undefined && 
        selectedAttr['insert-code'] === undefined 
      ) {
        setDisplayFlowData(false);
      }

      const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
      const tempTargets = ['none'];
      tempData.forEach((page) => {
        tempTargets.push(page.name);
      });
      setTargets(tempTargets);
    }
  }, [clickedEdit]);

  const selectTarget = (option) => {
    setTarget(option);
    if (option === 'none') {
      setTargetPageChecked(false);
      setHrefChecked(true);
    } else {
      setHrefChecked(false);
      setTargetPageChecked(true);
    }
  };
  
  const handleRadioChecked = (radioCompChecked,radioComp) => {

    if(radioCompChecked === false){
      if( radioComp === 'href'){
        setHrefChecked(true);
        setTargetPageChecked(false);
        setPreviousPageChecked(false);
        setInsertCustomCodeChecked(false)
      }
      else if( radioComp === 'previousPage'){
        setHrefChecked(false);
        setTargetPageChecked(false);
        setPreviousPageChecked(true);
        setInsertCustomCodeChecked(false);
      }
      else if(radioComp === 'targetPage'){
        setHrefChecked(false);
        setTargetPageChecked(true);
        setPreviousPageChecked(false);
        setInsertCustomCodeChecked(false);
      }
      else if(radioComp === 'insertCode'){
        setHrefChecked(false);
        setTargetPageChecked(false);
        setPreviousPageChecked(false);
        setInsertCustomCodeChecked(true);
      }
    }
  }

  const handleHref = (val) => {
    setHref(val.target.value);
    setTargetPageChecked(false);
    setHrefChecked(true);
  };

  const handleNewWindowChecked = () => {
    setNewWindowChecked(!newWindowChecked)
  }

  const handleTransitionByIdChecked = () => {
    setTransitionById(!transitionById);
  }

  return (
      <RadioMechanism
        editor={editor}
        hrefChecked={hrefChecked}
        handleHref={handleHref}
        href={href}
        targetPageChecked={targetPageChecked}
        target={target}
        targets={targets}
        selectTarget={selectTarget}
        previousPageChecked={previousPageChecked}
        handleRadioChecked={handleRadioChecked}
        insertCustomCodeChecked={insertCustomCodeChecked}
        setOpenAlert={setOpenAlert}
        transitionById={transitionById}
        handleTransitionByIdChecked={handleTransitionByIdChecked}
        newWindowChecked={newWindowChecked}
        handleNewWindowChecked={handleNewWindowChecked}
      />
  );
};

export default FlowDataMechanism;
